import { z } from "zod/v4";

import { castToNumber } from "../utils";

export const OnsiteInjectionsCodeTypeList = ["customCss", "customJs"] as const;

export type OnsiteInjectionsCodeType =
  (typeof OnsiteInjectionsCodeTypeList)[number];

export const JsInjectionModeTypeList = [
  "immediately",
  "onWindowLoad",
  "timeout",
] as const;
export type JsInjectionModeType = (typeof JsInjectionModeTypeList)[number];

export const JsInjectionModeDtoSchema = z.object({
  type: z
    .enum(JsInjectionModeTypeList)
    .default("immediately")
    .describe(
      "When to inject JS: 'immediately', 'onWindowLoad', 'timeout' (with delay)"
    ),
  timeout: castToNumber
    .optional()
    .describe("Delay in milliseconds when type is 'timeout'"),
});
export type JsInjectionModeDto = z.infer<typeof JsInjectionModeDtoSchema>;

export const OnsiteInjectionDtoSchema = z.object({
  id: z.uuid().describe("Unique identifier for the injection"),
  variationId: z.uuid().describe("Variation this injection belongs to"),
  customCss: z
    .preprocess(
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      (x) => (typeof x === "object" ? x?.toString() : x),
      z.string().nullish()
    )
    .describe("Custom CSS styles to inject into the page"),
  // add new key for custom js injection mode
  customJs: z
    .preprocess(
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      (x) => (typeof x === "object" ? x?.toString() : x),
      z.string().nullish()
    )
    .describe("Custom JavaScript code to execute on the page"),
  jsInjectionMode: JsInjectionModeDtoSchema.describe(
    "Configuration for when to inject the JavaScript"
  ),
});

export type OnsiteInjectionDto = z.infer<typeof OnsiteInjectionDtoSchema>;

export const CreateOnsiteInjectionDtoSchema = OnsiteInjectionDtoSchema.extend({
  id: z
    .uuid()
    .optional()
    .describe("Unique identifier (auto-generated if not provided)"),
});
export type CreateOnsiteInjectionDto = z.infer<
  typeof CreateOnsiteInjectionDtoSchema
>;
